import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContextMenu } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

/**
 * Present-only V2 options menu. This list page is read-only (#8549): it ships
 * the Options column so its placement is verified now, but the menu's actions
 * are deliberately inert. Per design (Figma node 2741:3353) the menu holds
 * "Disable" and "Delete"; the working flows (confirmation modals + the
 * destructive calls, which need the key model) are owned by a later child of
 * #8526 — that child reintroduces the `apiKey` prop. Both items render
 * disabled so the column reads as a placeholder rather than a functional
 * control.
 *
 * Unlike the V1 menu it never exposes a "copy key to clipboard" action — the
 * raw key value is never surfaced for a service key (security requirement of
 * #8549).
 */
function APIKeyOptionsV2(): JSX.Element {
  const { t } = useTranslation();

  return (
    <ContextMenu buttonType={'icon'} name={'api-key-options'} position={'left-start'}>
      <ContextMenu.Item disabled={true} name={'disable-key'} prefix={getIconForAction('disable')}>
        {t('Disable')}
      </ContextMenu.Item>
      <ContextMenu.Item
        disabled={true}
        name={'delete-key'}
        prefix={getIconForAction('delete')}
        theme={'danger'}
      >
        {t('Delete')}
      </ContextMenu.Item>
    </ContextMenu>
  );
}

export default APIKeyOptionsV2;
